import { APIDataUserSettings, APIMetaDataUserSettingsPropertyNames } from '@evertel/types'
import { Store } from '@evertel/types'
import { decorate, injectable } from '@evertel/di'

class UserSettingsStore extends Store<APIDataUserSettings> {
    constructor() {
        super(APIMetaDataUserSettingsPropertyNames)
    }
}

decorate(injectable(), UserSettingsStore)

export { UserSettingsStore }
